import React from "react";
import Laptop from "../assets/laptop.jpg";
import { SectionInterface } from "../interfaces/Section";

type Props = {
  sectionInterface: SectionInterface;
};

const SectionBelow: React.FC<Props> = ({ sectionInterface }) => {
  return (
    <div className="w-full bg-white py-16 px-4" id="about">
        <div className="max-w-[1240px] mx-auto grid md:grid-cols-2 items-center gap-6">
        <div>
          <img
            src={Laptop}
            alt="laptop"
            className="w-[100%] max-w-[500px] mx-auto my-4 rounded-lg object-cover"
          />
        </div>

        <div className="flex gap-2 items-center">
          <div className="p-2">
            <p className="text-[#00df9a] font-bold">
              Clean Code &amp; Best Practices
            </p>
            <h1 className="md:text-4xl sm:text-3xl text-2xl font-bold py-2">
              Efficiency and Code Quality
            </h1>
            <p className="text-gray-700">
              My projects are built with clean, maintainable, and scalable code
              following best practices. This ensures that applications are
              reliable, cost-efficient in the long run, and easy to extend as
              business needs evolve. I focus on quality and testing, which
              reduces technical debt and saves both time and money for future
              development.
            </p>
          </div>

          <div className="rotate-90 border-l-2 border-gray-200 pl-4 text-gray-400 font-bold">
            {sectionInterface.title}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionBelow;
